import dictUrl from "./words.json?url";
export interface Input {}

<let/words=null as null | string[]>

<link rel="preload" href=dictUrl as="fetch">

<script>
  fetch(dictUrl, {
    mode: "no-cors",
    credentials: "include",
  }).then(async (res) => {
    words = await res.json();
  });
</script>

<return=words>
